<div class="header-message" *ngIf="isShown() && message">
    <div class="text-center">{{message}}</div>
    <div (click)="hide()" style="position: absolute; right: 7px; top: 3px; cursor: pointer;">✘</div>
</div>